export default __webpack_public_path__ + "static/media/ic_polygon_24.4352380c.svg";